export const CHATWOOT_ERROR = 'qodeqChat:error';
export const CHATWOOT_ON_MESSAGE = 'qodeqChat:on-message';
export const CHATWOOT_ON_START_CONVERSATION = 'qodeqChat:on-start-conversation';
export const CHATWOOT_POSTBACK = 'qodeqChat:postback';
export const CHATWOOT_READY = 'qodeqChat:ready';
export const CHATWOOT_OPENED = 'qodeqChat:opened';
export const CHATWOOT_CLOSED = 'qodeqChat:closed';
